import { ContaReceberParcialForm } from "../../../presentation/schemas/ContasReceber_cadastro/ContasReceberParcial_form";
import { ICreateContasReceberParcialUseCase } from "../../../presentation/useCases/create/create_contas_receber_parcial_use_case";
import { ContasReceberParcialSituacao } from "../../models/recebimento_parcial";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateContasReceberParcialUseCase
 */

export class CreateContasReceberParcialUseCase implements ICreateContasReceberParcialUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createContasReceberParcial(form: ContaReceberParcialForm): Promise<ContasReceberParcialSituacao> {
    return await this.repository.createContasReceberParcial(form);

  }

}
